// D:\my-website\src\LanguageSwitcher.js

import React from 'react';
import { useTranslation } from 'react-i18next';

function LanguageSwitcher() {
  const { i18n, t } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div className="language-switcher flex justify-end p-4 bg-gray-100 rounded-b-lg shadow-sm">
      <button
        onClick={() => changeLanguage('zh')}
        className={`px-3 py-1 rounded-md text-sm font-medium transition duration-200 ease-in-out
          ${i18n.language === 'zh' ? 'bg-blue-600 text-white shadow-md' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}
          mr-2`}
      >
        {t('language_chinese')}
      </button>
      <button
        onClick={() => changeLanguage('en')}
        className={`px-3 py-1 rounded-md text-sm font-medium transition duration-200 ease-in-out
          ${i18n.language === 'en' ? 'bg-blue-600 text-white shadow-md' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}
          `}
      >
        {t('language_english')}
      </button>
    </div>
  );
}

export default LanguageSwitcher;
